module.exports = __webpack_public_path__ + "assets/img/xjfour.6f705f48.png";